export var dataHooks = {
  drillInListItemDescription: 'drill-in-list-item-description'
};